document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault(); // Prevent the default cart drawer action
            
            var formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(function(response) {
                if (response.ok) {
                    window.location.href = '/checkout'; // Redirect to the checkout page
                } else {
                    alert('There was an error adding the item to the cart.');
                }
            });
        });
    });
});
